/**
 * Busy Cursor
 *
 * Tracks busy tokens and toggles a global busy-cursor class on the document body.
 */

const BODY_CLASS = "is-busy-cursor";

function createBusyTokensSet(): Set<string> {
    return new Set();
}

class BusyCursor {
    private _tokens: Set<string>;

    public constructor() {
        this._tokens = createBusyTokensSet();
    }

    public start(): string {
        const token = `busy-${Date.now()}-${Math.random().toString(16).slice(2)}`;
        this._tokens.add(token);
        this._apply();
        return token;
    }

    public stop(token: string | null | undefined): void {
        if (!token) return;
        this._tokens.delete(token);
        this._apply();
    }

    public clear(): void {
        this._tokens.clear();
        this._apply();
    }

    private _apply(): void {
        try {
            if (typeof document === "undefined" || !document.body) return;

            if (this._tokens.size > 0) {
                document.body.classList.add(BODY_CLASS);
            } else {
                document.body.classList.remove(BODY_CLASS);
            }
        } catch (_error) {
            // ignore DOM access failures
        }
    }
}

const busyCursor = new BusyCursor();

export { busyCursor };
export const BUSY_CURSOR_BODY_CLASS = BODY_CLASS;
